import React from 'react';

import classes from '../../css/getCSS';


const alert = (props) => {
  const alertClasses = [classes.Alert];

  if (props.type === 'primary') {
    alertClasses.push(classes.alertPrimary);
  } else if (props.type === 'success') {
    alertClasses.push(classes.alertSuccess);
  } else if (props.type === 'danger') {
    alertClasses.push(classes.alertDanger);
  } else if (props.type === 'info') {
    alertClasses.push(classes.alertInfo);
  } else if (props.type === 'grey') {
    alertClasses.push(classes.alertGrey);
  }

  return (
    <div className={alertClasses.join(' ')}>
      {props.children}
    </div>
  );
};

export default alert;



// WEBPACK FOOTER //
// ./src/common/components/Alert.js